import React, {PureComponent} from 'react'
import styled from 'styled-components'

import {Icon} from './Icon'


const Container = styled.div`
  width: 100%;
  height:100%;
  background: transparent;
  display: flex;
  padding: 20px; 
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 999999;
  top:0px;
  left:0px;
  flex-direction:column;
`


class Loader extends PureComponent{
  state={
    open: false
  }
  render(){
    const {loaderMsg}=this.props
    return(
      <Container>
        <Icon icon='loader'/>
        {loaderMsg}
      </Container>
     
    )
  }
}

export {Loader}